/* =========================================================
   Maison · Wishlist
   - Corazones [data-mwish] en tarjetas y ficha; ícono del header [data-mwish-head] con un punto cuando hay piezas.
   - Con sesión iniciada la lista vive en la cuenta del cliente (app "Hype Wishlist": App Proxy /apps/hypewish ->
     Vercel hype-wishlist, metacampo maison.wishlist). Lo guardado sin sesión se suma a la cuenta al iniciar sesión.
   - Sin sesión (o si la app no responde) se guarda en este navegador (localStorage "maison-wish").
   - <maison-wishlist> (sections/maison-wishlist.liquid) dibuja las piezas guardadas con la Section Rendering API.
   Textos en window.MaisonWishCfg (snippets/maison-head.liquid).
   ========================================================= */
(function () {
  'use strict';
  if (window.MaisonWish) return;

  var CFG = window.MaisonWishCfg || {};
  var T = CFG.t || {};
  var KEY = 'maison-wish';
  var MAX = 100;

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v.filter(Boolean) : []; } catch (e) { return []; }
  }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }

  var KEY_ACCT = 'maison-wish:acct';
  var mode = 'local';
  var list = CFG.logged ? (read2(KEY_ACCT).length ? read2(KEY_ACCT) : read()) : read();
  function has(h) { return list.indexOf(h) > -1; }
  function read2(k) { try { var v = JSON.parse(localStorage.getItem(k) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function save() {
    try { localStorage.setItem(mode === 'server' ? KEY_ACCT : KEY, JSON.stringify(list)); } catch (e) {}
  }
  function api(method, body) {
    return fetch(CFG.endpoint, {
      method: method,
      credentials: 'same-origin',
      headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      var ct = r.headers.get('content-type') || '';
      if (!r.ok || ct.indexOf('json') < 0) throw new Error('wish ' + r.status);
      return r.json();
    });
  }

  function paintButtons(scope) {
    var btns = scope.matches && scope.matches('[data-mwish]') ? [scope] : scope.querySelectorAll('[data-mwish]');
    Array.prototype.forEach.call(btns, paintOne);
  }
  function paintOne(b) {
    var on = has(b.getAttribute('data-mwish'));
    if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', String(on));
    var t = on ? T.remove : T.add;
    if (t && b.title !== t) b.title = t;
  }
  function paint(scope) {
    (scope || document).querySelectorAll('[data-mwish]').forEach(function (b) {
      var on = has(b.getAttribute('data-mwish'));
      if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', String(on));
      var t = on ? T.remove : T.add;
      if (t && b.title !== t) b.title = t;
    });
    document.querySelectorAll('[data-mwish-head]').forEach(function (a) {
      if (a.classList.contains('has-items') !== list.length > 0) a.classList.toggle('has-items', list.length > 0);
      var lbl = list.length ? (T.head_items || T.head) : T.head;
      if (lbl && a.getAttribute('aria-label') !== lbl) a.setAttribute('aria-label', lbl);
    });
  }

  var toastEl, toastTimer;
  function toast(text, link, href) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'mwish-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = '';
    var span = document.createElement('span');
    span.textContent = text;
    toastEl.appendChild(span);
    if (link && (href || CFG.page)) {
      var a = document.createElement('a');
      a.href = href || CFG.page;
      a.textContent = link;
      toastEl.appendChild(a);
    }
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  function toggle(h, btn) {
    if (!h) return;
    var on = !has(h);
    list = list.filter(function (x) { return x !== h; });
    var prev = list.slice();
    if (on) { list.unshift(h); if (list.length > MAX) list = list.slice(0, MAX); }
    save();
    paint();
    if (mode === 'server') {
      api('POST', { op: on ? 'add' : 'remove', handles: [h] })
        .then(function (d) { if (d && d.logged && Array.isArray(d.handles)) { list = d.handles; save(); paint(); } })
        .catch(function () { list = prev; save(); paint(); toast(T.error || 'Error'); });
    }
    if (btn && on) { btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop'); }
    var onPage = !!document.querySelector('maison-wishlist');
    if (on && !onPage) {
      if (mode === 'local' && !CFG.logged && CFG.login) {
        var tipSeen = false;
        try { tipSeen = !!localStorage.getItem('maison-wish:tip'); localStorage.setItem('maison-wish:tip', '1'); } catch (e) {}
        if (!tipSeen) toast(T.login_tip || T.added, T.login, CFG.login);
        else toast(T.added || 'Saved', T.view);
      } else {
        toast(T.added || 'Saved', T.view);
      }
    }
    if (!on && !onPage) toast(T.removed || 'Removed');
    document.dispatchEvent(new CustomEvent('maison:wishlist', { detail: { list: list.slice(), handle: h, on: on } }));
  }

  // Captura: el corazón está dentro de tarjetas con enlace extendido
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mwish]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(b.getAttribute('data-mwish'), b);
  }, true);

  // Otras pestañas
  window.addEventListener('storage', function (e) {
    if (e.key !== (mode === 'server' ? KEY_ACCT : KEY)) return;
    list = mode === 'server' ? read2(KEY_ACCT) : read();
    paint();
  });

  // Tarjetas que se cargan después (filtros, recomendaciones, vista rápida).
  // Solo mira los nodos nuevos que traen corazones: antes repintaba toda la página con cualquier cambio del DOM
  // (scripts de terceros, carruseles…) y eso consumía varios segundos de CPU.
  var nuevos = [];
  var queued = false;
  function pintarNuevos() {
    queued = false;
    var lote = nuevos; nuevos = [];
    lote.forEach(function (n) { if (n.isConnected) paintButtons(n); });
  }
  function observar() {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches('[data-mwish]') || n.querySelector('[data-mwish]')) nuevos.push(n);
        }
      }
      if (nuevos.length && !queued) { queued = true; requestAnimationFrame(pintarNuevos); }
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- Página Wishlist ---------- */
  if (!customElements.get('maison-wishlist')) {
    customElements.define('maison-wishlist', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-mwl-grid]');
        this.empty = this.querySelector('[data-mwl-empty]');
        this.count = this.closest('.mwl') && this.closest('.mwl').querySelector('[data-mwl-count]');
        this.onChange = this.onChange.bind(this);
        document.addEventListener('maison:wishlist', this.onChange);
        this.render();
      }
      disconnectedCallback() { document.removeEventListener('maison:wishlist', this.onChange); }
      setCount() {
        var n = this.grid.children.length;
        if (this.count) {
          this.count.hidden = !n;
          this.count.textContent = n === 1 ? (T.one || '1') : (T.many || '%n').replace('%n', n);
        }
        this.empty.hidden = n > 0;
        this.toggleAttribute('data-empty', n === 0);
      }
      onChange(e) {
        var d = e.detail || {};
        if (d.on) { this.render(); return; }
        var item = this.grid.querySelector('[data-mwish-item="' + CSS.escape(d.handle) + '"]');
        if (!item) return;
        item.classList.add('is-removing');
        setTimeout(() => { item.remove(); this.setCount(); }, 350);
      }
      render() {
        var handles = list.slice();
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var self = this;
        if (!handles.length) { this.grid.innerHTML = ''; this.setCount(); return; }
        Promise.all(handles.map(function (h) {
          return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=maison-wish-card')
            .then(function (r) { return r.ok ? r.text() : ''; })
            .catch(function () { return ''; });
        })).then(function (htmls) {
          var frag = document.createDocumentFragment();
          var gone = [];
          htmls.forEach(function (html, i) {
            var tpl = document.createElement('template');
            tpl.innerHTML = html;
            var li = tpl.content.querySelector('[data-mwish-item]');
            if (li) frag.appendChild(li);
            else gone.push(handles[i]);
          });
          // Piezas que ya no están en la tienda: se sacan de la lista
          if (gone.length) { list = list.filter(function (h) { return gone.indexOf(h) < 0; }); save(); }
          self.grid.innerHTML = '';
          self.grid.appendChild(frag);
          paint(self);
          self.setCount();
          if (window.Maison && window.Maison.reveal) window.Maison.reveal(self);
        });
      }
    });
  }

  // Cuenta: trae la lista guardada y le suma lo que se guardó en este navegador antes de iniciar sesión
  function syncAccount() {
    if (!CFG.logged || !CFG.endpoint) return;
    api('GET').then(function (d) {
      if (!d || !d.logged) throw new Error('sin sesión');
      mode = 'server';
      var server = Array.isArray(d.handles) ? d.handles : [];
      var guest = read().filter(function (h) { return server.indexOf(h) < 0; });
      list = server;
      if (!guest.length) { save(); paint(); refreshPage(); return; }
      list = server.concat(guest).slice(0, MAX); save(); paint();
      return api('POST', { op: 'merge', handles: guest }).then(function (m) {
        if (m && Array.isArray(m.handles)) list = m.handles;
        save();
        try { localStorage.removeItem(KEY); } catch (e) {}
        paint();
        refreshPage();
      });
    }).catch(function () { mode = 'local'; });
  }
  function refreshPage() {
    var page = document.querySelector('maison-wishlist');
    if (page && page.render) page.render();
  }

  window.MaisonWish = { list: function () { return list.slice(); }, has: has, toggle: toggle };
  syncAccount();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { paint(); observar(); });
  else { paint(); observar(); }
})();
